import { GAME_ID } from '../../data';

const defaultState = {
  isBackButtonVisible: true,
  shouldStartIncorrectOnboardingAnimation: false,
  incorrectAnswersCount: 0,
  incorrectAnswerIds: [],
  isAudioPlaying: false,
  shouldDisplayHint: false,
  shouldDisplayCorrectAnswer: false,
  lastAlexAudio: '',
};

const storyReducer = (state = defaultState, { type, gameId, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }
  switch (type) {
    case 'SHOW_HINT':
      return {
        ...state,
        shouldDisplayHint: true,
      };
    case 'HIDE_HINT':
      return {
        ...state,
        shouldDisplayHint: false,
      };
    case 'WRONG_ANSWER_GIVEN':
      return {
        ...state,
        incorrectAnswersCount: state.incorrectAnswersCount + 1,
        incorrectAnswerIds: [...state.incorrectAnswerIds, payload.id],
      };
    case 'SHOW_CORRECT_ANSWER':
      return {
        ...state,
        shouldDisplayCorrectAnswer: true,
        shouldDisplayHint: false,
      };
    case 'SET_LAST_ALEX_AUDIO':
      return {
        ...state,
        lastAlexAudio: payload.audio,
      };
    case 'RESET_STORY_STATE':
      return {
        ...state,
        isBackButtonVisible: true,
        shouldStartIncorrectOnboardingAnimation: false,
        incorrectAnswersCount: 0,
        incorrectAnswerIds: [],
        shouldDisplayHint: false,
        shouldDisplayCorrectAnswer: false,
        lastAlexAudio: '',
      };
    case 'SET_AUDIO_PLAYING':
      return {
        ...state,
        isAudioPlaying: payload.isAudioPlaying,
      };
    case 'START_INCORRECT_ONBOARDING_ANIMATION':
      return {
        ...state,
        shouldStartIncorrectOnboardingAnimation: true,
      };
    case 'TOGGLE_BACK_BUTTON':
      return { ...state, isBackButtonVisible: payload };
    default:
      return state;
  }
};

export default storyReducer;
